<template>
  <div class="pb-0">
    <div
      id="custom-message-header"
      class="container-fluid custom-message-header topbar-module topbar-module--message"
      :class="[getBgCustomMessage(), topBarModuleClass('message')]"
      v-if="settings.customMessage && topBarModuleEnabled('message', true)"
    >
      <div class="row no-gutters">
        <div
          class="col text-center text-uppercase py-1 font-weight-bold"
          style="font-size: 0.8rem"
        >
          {{ settings.customMessage }}
        </div>
      </div>
    </div>
    <div
      id="pre-header"
      class="container-fluid bg-dark text-white mini-header px-2 topbar"
    >
      <div class="container px-0 topbar__container" style="max-width: 1300px">
        <div class="topbar__inner py-1">
          <div
            class="topbar__services text-uppercase"
            v-if="showTopBarServices"
          >
            <b-badge
              class="mr-1 my-1 text-dark topbar-module topbar-module--status"
              :class="topBarModuleClass('status')"
              id="badge-schedule"
              variant="light"
              v-if="topBarModuleEnabled('status', settings.style == 'delivery')"
              ><span
                class="badge-notif d-inline-block mr-1"
                :class="{
                  'bg-danger': status() == 'Offline',
                  'bg-success': status() == 'Online',
                }"
              ></span
              >{{ status() == "Online" ? "Abierto" : "Cerrado" }}</b-badge
            >
            <b-badge
              id="badge-today"
              class="mr-1 click topbar-module topbar-module--schedule"
              :class="topBarModuleClass('schedule')"
              v-if="today() && topBarModuleEnabled('schedule', settings.style == 'delivery')"
              @click="showSchedule()"
            >
              <span>{{ today() }}</span></b-badge
            >
            <b-badge
              class="mr-1 topbar-module topbar-module--pickup"
              :class="topBarModuleClass('pickup')"
              id="badge-pickup"
              v-if="settings.showPickup && topBarModuleEnabled('pickup', settings.style == 'delivery')"
              :variant="settings.pickupEnabled ? 'success' : 'danger'"
            >
              <b-icon
                icon="x-circle-fill"
                class="text-white"
                v-if="!settings.pickupEnabled"
              />
              Retiro
              <span v-if="settings.pickupWaitTime && settings.pickupEnabled"
                >({{ settings.pickupWaitTime }} min)</span
              ></b-badge
            >
            <b-badge
              id="badge-delivery"
              class="mr-1 topbar-module topbar-module--delivery"
              :class="topBarModuleClass('delivery')"
              v-if="settings.showDelivery && topBarModuleEnabled('delivery', settings.style == 'delivery')"
              :variant="settings.deliveryEnabled ? 'success' : 'danger'"
            >
              <b-icon
                icon="x-circle-fill"
                class="text-white"
                v-if="!settings.deliveryEnabled"
              />
              Reparto
              <span v-if="settings.deliveryWaitTime && settings.deliveryEnabled"
                >({{ settings.deliveryWaitTime }} min)</span
              ></b-badge
            >

            <b-badge
              class="mr-1 topbar-module topbar-module--wait-time"
              :class="topBarModuleClass('waitTime')"
              v-if="settings.waitTime && topBarModuleEnabled('waitTime', false)"
              variant="dark"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                fill="currentColor"
                class="bi bi-alarm"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8.5 5.5a.5.5 0 0 0-1 0v3.362l-1.429 2.38a.5.5 0 1 0 .858.515l1.5-2.5A.5.5 0 0 0 8.5 9V5.5z"
                />
                <path
                  d="M6.5 0a.5.5 0 0 0 0 1H7v1.07a7.001 7.001 0 0 0-3.273 12.474l-.602.602a.5.5 0 0 0 .707.708l.746-.746A6.97 6.97 0 0 0 8 16a6.97 6.97 0 0 0 3.422-.892l.746.746a.5.5 0 0 0 .707-.708l-.601-.602A7.001 7.001 0 0 0 9 2.07V1h.5a.5.5 0 0 0 0-1h-3zm1.038 3.018a6.093 6.093 0 0 1 .924 0 6 6 0 1 1-.924 0zM0 3.5c0 .753.333 1.429.86 1.887A8.035 8.035 0 0 1 4.387 1.86 2.5 2.5 0 0 0 0 3.5zM13.5 1c-.753 0-1.429.333-1.887.86a8.035 8.035 0 0 1 3.527 3.527A2.5 2.5 0 0 0 13.5 1z"
                />
              </svg>
              <span class="ml-1 d-inline-block text-break">{{
                getWaitTime(settings.waitTime)
              }}</span></b-badge
            >

            <b-badge
              class="mr-1 h-100 topbar-module topbar-module--min-delivery"
              :class="topBarModuleClass('minDelivery')"
              v-if="settings.minDelivery && topBarModuleEnabled('minDelivery', settings.style == 'delivery')"
              id="badge-min-delivery"
              variant="info"
              >Reparto desde ${{ formatNumber(settings.minDelivery) }}</b-badge
            >
          </div>
          <div class="topbar__actions">
            <div class="topbar__social" v-if="showTopBarSocial">
              <div
                class="topbar-module topbar-module--facebook"
                :class="topBarModuleClass('facebook')"
                v-if="settings.facebook && topBarModuleEnabled('facebook', true)"
              >
                <a
                  :href="`https://facebook.com/${settings.facebook}`"
                  target="_blank"
                  ><b-icon icon="facebook"></b-icon
                ></a>
              </div>
              <div
                class="topbar-module topbar-module--instagram"
                :class="topBarModuleClass('instagram')"
                v-if="settings.instagram && topBarModuleEnabled('instagram', true)"
              >
                <a
                  :href="`https://instagram.com/${settings.instagram}`"
                  target="_blank"
                >
                  <b-icon icon="instagram"></b-icon
                ></a>
              </div>
            </div>
            <div
              class="topbar__account topbar-module topbar-module--account"
              :class="topBarModuleClass('account')"
              v-if="topBarModuleEnabled('account', true)"
            >
            <b-dropdown
              id="dropdown-form"
              variant="dark"
              text="CUENTA"
              aria-label="Cuenta"
              block
              right
              class="text-white text-uppercase"
              ref="dropdown"
              size="sm"
            >
              <template #button-content>
                <b-icon icon="person" class="mr-2" aria-hidden="true"></b-icon>
                <span class="topbar__account-label">CUENTA</span>
              </template>
              <div v-if="!isLogged()" style="width: 240px">
                <b-dropdown-item-button
                  @click="$router.push(getLink('ingresar'))"
                  >Ingresar
                </b-dropdown-item-button>
                <b-dropdown-item-button
                  @click="$router.push(getLink('registro'))"
                  >Crear cuenta</b-dropdown-item-button
                >
              </div>
              <div v-else>
                <b-dropdown-item-button
                  @click="$router.push(getLink('cuenta'))"
                >
                  Mis pedidos
                </b-dropdown-item-button>
                <b-dropdown-item-button @click="logout()">
                  Cerrar session
                </b-dropdown-item-button>
              </div>
            </b-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid message-offline w-100 overflow-hidden">
      <div class="container">
        <div class="fixed-bottom" v-if="status() == 'Offline' && appInit">
          <div
            class="alert alert-danger font-weight-bold text-center mb-0 rounded-0"
          >
            <div class="row align-items-center no-gutters">
              <div class="col px-4 text-uppercase">
                {{ info.custom_name || info.name }} no esta disponible
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="menuPosition === 'fixed'"
      ref="headerSpacer"
      class="header-fixed-spacer"
      :style="{ height: `${menuHeight}px` }"
      aria-hidden="true"
    ></div>
    <div
      class="container-fluid header overflow-hidden position-relative"
      style="z-index: 2"
      :class="[getTheme(), menuPositionClass]"
      ref="siteHeader"
    >
      <img
        src=""
        id="img-header"
        style="opacity: 0.1; top: -100%; left: 0; width: 100%; height: 350px"
        class="position-absolute"
      />
      <div
        id="header"
        class="row py-3 align-items-center justify-items-center"
        style="max-width: 1300px; margin: 0 auto"
      >
        <div class="col-12" v-if="showHeader">
          <div
            class="row no-gutters align-items-center"
            :class="getThemeText()"
          >
            <!-- <div class="col-2 text-center d-none">
              <img
                :src="getLogo(info.logo)"
                class="img-fluid"
                style="max-height: 80px"
              />
            </div> -->

            <b-navbar
              :variant1="settings.headerColor"
              type="light"
              class="w-100 header-navbar"
              :class="menuClasses"
              toggleable="lg"
            >
              <b-navbar-brand>
                <div>
                  <div class="row">
                    <div class="col-auto col-md-4 click" @click="goHome()">
                      <img
                        :src="getLogo(info.logo)"
                        class="img-fluid1"
                        id="logo"
                        @load="updateMenuHeight"
                      />
                    </div>
                    <div class="col-8 pl-5" id="name">
                      <span
                        style="font-size: 1.1em"
                        class="d-none d-sm-inline-block"
                      >
                        {{ info.custom_name || info.name }}
                      </span>
                      <small v-if="settings.headerSubtitle" class="header-brand__subtitle">
                        {{ settings.headerSubtitle }}
                      </small>
                      <div class="font-italic" v-if="todayRaw() && false">
                        <small class="d-block">
                          abierto
                          {{ $moment(todayRaw().openAt, "HH:mm:ss").fromNow() }}
                        </small>
                        <small class="d-block">
                          cierra
                          {{
                            $moment(todayRaw().closeAt, "HH:mm:ss").fromNow()
                          }}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </b-navbar-brand>
              <b-navbar-toggle target="navbar-toggle-collapse">
                <template #default="{ expanded }">
                  <b-icon
                    v-if="expanded"
                    :class="getThemeText()"
                    icon="card-list"
                  ></b-icon>
                  <b-icon v-else :class="getThemeText()" icon="list"></b-icon>
                </template>
              </b-navbar-toggle>

              <b-collapse id="navbar-toggle-collapse" is-nav>
                <b-navbar-nav class="ml-auto">
                  <div
                    class="nav-item"
                    v-for="page in info.pages"
                    :key="page._id"
                  >
                    <router-link
                      class="nav-link text-uppercase h-100 align-items-center d-flex"
                      :class="{ 'header-nav__cart': page.slug == 'pedido' }"
                      :exact="page.slug == ''"
                      active-class="font-weight-bold"
                      :to="getLink(page.slug)"
                      ><b-icon
                        v-if="page.icon"
                        style="font-size: 1em !important"
                        :icon="page.icon"
                        class="mr-1"
                      >
                      </b-icon>
                      <!-- <div class="w-100"></div> -->
                      <span class="mx-2">{{ page.title }}</span>

                      <span
                        v-if="page.slug == 'pedido'"
                        class="badge badge-danger px-2"
                        >${{ formatNumber(total) }}</span
                      >
                    </router-link>
                  </div>
                </b-navbar-nav>
              </b-collapse>
            </b-navbar>
          </div>
        </div>
        <div class="w-100 mt-3 header__spacer"></div>
      </div>
    </div>
    <div id="content" style="min-height: 60vh">
      <router-view class="animate__animated animate__fadeIn"></router-view>
    </div>

    <div
      class="overflow-hidden"
      v-if="settings.whatsapp"
      style="
        border-radius: 1500px;
        position: fixed;
        bottom: 130px;
        right: 30px;
        z-index: 99;
      "
    >
      <button
        id="wspbtn"
        class="btn bg-success text-white px-1"
        style="width: 35px; height: 35px"
        @click="goWhatsApp()"
      >
        <b-icon icon="whatsapp"></b-icon>
      </button>
      <b-tooltip
        target="wspbtn"
        placement="left"
        triggers="hover"
        :show1.sync="show"
        style="z-index: 2"
      >
        Hablar al WhatsApp
      </b-tooltip>
    </div>

    <div
      v-if="showFloatingCart"
      class="floating-cart"
      :class="{ 'floating-cart--with-whatsapp': settings.whatsapp }"
    >
      <router-link class="floating-cart__button" :to="getLink('pedido')">
        <span class="floating-cart__icon">
          <b-icon icon="cart-fill"></b-icon>
        </span>
        <span class="floating-cart__text">
          <small class="d-block">Ver pedido</small>
          <strong>${{ formatNumber(cartTotal) }}</strong>
        </span>
        <span class="floating-cart__badge">{{ cartCount }}</span>
      </router-link>
    </div>

    <div
      class="overflow-hidden rounded-circle"
      style="position: fixed; bottom: 80px; right: 30px; z-index: 99"
    >
      <button
        class="btn bg-primary text-white px-1"
        style="width: 35px; height: 35px"
        @click="goUp()"
      >
        <b-icon icon="arrow-up"></b-icon>
      </button>
    </div>

    <div
      class="py-5 mt-0 footer"
      id="footer"
      :class="getThemeFooter()"
      v-if="showFooter"
    >
      <div class="w-100 py-0"></div>
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-5 mb-4 mb-lg-0 text-center text-lg-left">
            <img
              v-if="footerLogoSrc"
              :src="footerLogoSrc"
              class="web-footer__logo img-fluid mb-3"
              :alt="info.custom_name || info.name"
            />
            <div class="font-weight-bold web-footer__brand" id="footer-name">
              {{ info.custom_name || info.name }}
            </div>
            <small v-if="settings.footerDescription" class="d-block web-footer__description">
              {{ settings.footerDescription }}
            </small>
            <small v-else class="d-block web-footer__description">
              {{ info.address }} - {{ info.commune }}
            </small>
            <div class="web-footer__socials mt-3">
              <a
                v-if="settings.facebook"
                :href="`https://facebook.com/${settings.facebook}`"
                target="_blank"
                rel="noopener noreferrer"
                class="web-footer__social-link"
              >
                <b-icon icon="facebook"></b-icon>
              </a>
              <a
                v-if="settings.instagram"
                :href="`https://instagram.com/${settings.instagram}`"
                target="_blank"
                rel="noopener noreferrer"
                class="web-footer__social-link"
              >
                <b-icon icon="instagram"></b-icon>
              </a>
              <a
                v-if="settings.whatsapp"
                :href="`https://wa.me/${settings.whatsapp}`"
                target="_blank"
                rel="noopener noreferrer"
                class="web-footer__social-link"
              >
                <b-icon icon="whatsapp"></b-icon>
              </a>
            </div>
          </div>

          <div
            v-if="resolvedFooterLinks.length"
            class="col-12 col-lg-3 mb-4 mb-lg-0 text-center text-lg-left"
          >
            <div class="font-weight-bold web-footer__section-title">
              Información
            </div>
            <div class="web-footer__links">
              <router-link
                v-for="link in resolvedFooterLinks"
                :key="`footer-link-${link.slug || link.ref || link.label}`"
                :to="getLink(link.slug ? `/${link.slug}` : '')"
                class="web-footer__page-link"
              >
                {{ link.label }}
              </router-link>
            </div>
          </div>

          <div class="col-12 col-lg-4 text-center text-lg-left">
            <div class="font-weight-bold web-footer__section-title">
              Contacto
            </div>
            <small class="d-block" v-if="info.address">
              {{ info.address }}<span v-if="info.commune"> - {{ info.commune }}</span>
            </small>
            <small class="d-block">{{ info.phone }}</small>
            <div class="web-footer__utility-links mt-3">
              <a
                v-if="info.address"
                class="web-footer__map-link"
                @click="openAddres()"
              >
                Ver en Maps
              </a>
              <a v-if="settings.days" @click="showSchedule()">Horario</a>
              <router-link :to="getLink('tos')">
                Terminos y condiciones
              </router-link>
            </div>

            <div class="font-weight-bold web-footer__section-title mt-4">
              Mi cuenta
            </div>
            <div class="web-footer__utility-links">
              <template v-if="!isLogged()">
                <router-link :to="getLink('ingresar')">
                  Iniciar sesión
                </router-link>
                <router-link :to="getLink('registro')">
                  Registrarse
                </router-link>
              </template>
              <template v-else>
                <router-link :to="getLink('cuenta')">
                  Mi cuenta
                </router-link>
                <router-link :to="getLink('cuenta')">
                  Mis pedidos
                </router-link>
                <a @click="logout()">Cerrar sesión</a>
              </template>
            </div>
          </div>
        </div>

        <div class="row my-4">
          <div class="col-12 text-center">
            <small class="text-muted">
              {{ info.custom_name || info.name }} &copy; {{ $moment().format("YYYY") }}
              · Sitio web por
              <a href="http://ticketapp.cl" target="_blank" class="link">TicketApp</a>
            </small>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      ref="schedule-modal"
      modal-class="schedule-modal"
      content-class="schedule-modal__content"
      body-class="schedule-modal__body"
      hide-header
      hide-footer
      size="lg"
    >
      <opening-hours modal @close="$refs['schedule-modal'].hide()" />
    </b-modal>

    <b-modal
      ref="modal-create"
      size="lg"
      title="Crear cuenta"
      @ok="createAccount()"
    >
      <div class="d-none1">
        <div class="row">
          <div class="col-12">
            <strong>NOMBRE</strong>
          </div>
          <div class="col">
            <input
              type="text"
              class="form-control"
              v-model="clientName"
              :class="{
                'is-invalid': clientName.length < 4,
                'is-valid': clientName.length >= 4,
              }"
            />
            <small class="text-muted"
              >Tu nombre y apellido. Ej: Juan Segura</small
            >
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <strong>CORREO</strong>
          </div>
          <div class="col">
            <input
              type="email"
              autocapitalize="off"
              class="form-control"
              v-model="email"
              :class="{
                'is-invalid': emailIsValid,
                'is-valid': !emailIsValid,
              }"
            />
            <small class="text-muted">Ej: tu@gmail.com</small>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <strong>CONTRASEÑA</strong>
          </div>
          <div class="col">
            <input
              type="password"
              class="form-control"
              v-model="password"
              :class="{
                'is-invalid': password.length < 6,
                'is-valid': password.length >= 6,
              }"
            />
            <small class="text-muted">Minimo 6 caracteres</small>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <strong>REPITA CONTRASEÑA</strong>
          </div>
          <div class="col">
            <input
              type="password"
              class="form-control"
              v-model="repassword"
              :class="{
                'is-invalid': password.length < 6 || password != repassword,
                'is-valid': password.length >= 6,
              }"
            />
            <small class="text-muted">Minimo 6 caracteres</small>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <strong>TELEFONO</strong>
          </div>
          <div class="col">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">+56</span>
              </div>
              <input
                type="phone"
                class="form-control"
                v-model.number="phone"
                :class="{
                  'is-invalid': phone.toString().length != 9,
                  'is-valid': phone.toString().length == 9,
                }"
              />
            </div>
            <small class="text-muted">Ej: 987654321</small>
          </div>
          <div class="col-12 mt-4">
            <div class="alert alert-info">
              <small
                >AL ACEPTAR ACEPTAR HABER LEIDO LOS
                <router-link class="font-weight-bold" :to="getLink('tos')"
                  >TERMINOS Y CONDICIONES</router-link
                >.
                <br />
                CREARAS UNA CUENTA PARA TODAS LAS COMPRAS QUE REALICES EN LOS
                COMERCIOS ASOCIADOS A TICKETAPP.CL</small
              >
            </div>
          </div>
        </div>
      </div>
      <div class="row d-none">
        <div class="col">
          <h3>1. Debes tener pedidos realizados con anterioridad</h3>
        </div>
      </div>
    </b-modal>

    <b-modal
      modal-class="product-modal"
      content-class="product-modal__content"
      header-class="product-modal__header"
      body-class="product-modal__body"
      ref="modal"
      :title="productName"
      title-class="text-uppercase"
      size="lg"
      id="modal-product"
      scrollable
      hide-footer
      no-close-on-backdrop
      @hide="closeModal()"
    >
      <product
        v-if="modalProduct && pid"
        :key="pid"
        :id="pid"
        :initial-product="modalProduct"
        @loaded="productName = $event"
        @update="updateProductData"
        @load-error="handleModalProductError"
        @success="closeModal()"
        :textColor="getThemeText()"
      />
    </b-modal>

    <b-modal ref="modal-recover" title="Recuperar cuenta" @ok="sendRecover()">
      <div class="row">
        <div class="col-12">
          <strong>RECUPERAR CONTRASEÑA</strong>
        </div>
        <div class="col">
          <input
            type="email"
            class="form-control"
            v-model="email"
            :class="{
              'is-invalid': emailIsValid,
              'is-valid': !emailIsValid,
            }"
          />
          <small class="text-muted">Ingreso tu correo</small>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// import Product from "./pages/Product.vue";
const Product = () => import("./pages/Product.vue");
const OpeningHours = () => import("./components/openingHours.vue");
export default {
  components: {
    Product,
    OpeningHours,
  },
  name: "App",
  data() {
    return {
      attempt: 0,
      pid: null,
      modalProduct: null,
      modalProductKey: "",
      pendingProductKey: "",
      productRequestId: 0,
      productName: "",
      timeout: null,
      showUp: false,
      lastScroll: 0,
      showUpButton: true,
      showHeader: true,
      showFooter: true,
      nstatus: false,
      email: "",
      password: "",
      repassword: "",
      appInit: false,
      show: false,
      clientName: "",
      phone: "",
      loading: false,
      menuHeight: 0,
      menuResizeObserver: null,
    };
  },
  mounted() {
    // redirect if url start with www
    if (document.location.href.indexOf("www.") != -1) {
      console.log("contiene www.");
      document.location.href = document.location.href.replace("www.", "");
    }

    if (this.$route.query.header == false) this.showHeader = false;
    if (this.$route.query.footer == false) this.showFooter = false;
    this.load();

    if (this.$cookies.get("clientName"))
      this.clientName = this.$cookies.get("clientName");
    if (this.$cookies.get("phone")) this.phone = this.$cookies.get("phone");
    if (this.$cookies.get("email")) this.email = this.$cookies.get("email");

    // window.addEventListener("scroll", () => {
    //   if (window.scrollY > 300) this.showUpButton = true;
    //   if (window.scrollY > 300 && this.lastScroll > window.scrollY) {
    //     this.showUp = true;
    //   } else {
    //     this.showUp = false;
    //   }
    //   this.lastScroll = window.scrollY;
    // });
    this.$bus.$on("open-product-modal", ({ pid, pname }) => {
      console.log("open-product-modal received in App", { pid, pname });
      this.viewProduct(pid, pname || "");
    });
    this.checkProduct();
    this.$nextTick(() => {
      this.updateMenuHeight();
      window.addEventListener("resize", this.updateMenuHeight);
      window.addEventListener("scroll", this.updateMenuPosition, { passive: true });
      if (window.ResizeObserver && this.$refs.siteHeader) {
        this.menuResizeObserver = new ResizeObserver(this.updateMenuHeight);
        this.menuResizeObserver.observe(this.$refs.siteHeader);
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateMenuHeight);
    window.removeEventListener("scroll", this.updateMenuPosition);
    if (this.menuResizeObserver) this.menuResizeObserver.disconnect();
  },
  methods: {
    updateMenuHeight() {
      const header = this.$refs.siteHeader;
      if (!header) return;
      const height = header.offsetHeight;
      if (height !== this.menuHeight) this.menuHeight = height;
      this.updateMenuPosition();
    },
    updateMenuPosition() {
      if (this.menuPosition !== "fixed") return;
      const header = this.$refs.siteHeader;
      const spacer = this.$refs.headerSpacer;
      if (header && spacer) {
        header.style.top = `${Math.max(0, spacer.getBoundingClientRect().top)}px`;
      }
    },
    topBarModuleEnabled(name, defaultVisible) {
      const module = this.settings.topBarModules && this.settings.topBarModules[name];
      if (typeof module === "boolean") return module;
      if (module && typeof module.enabled === "boolean") return module.enabled;
      return defaultVisible;
    },
    topBarModuleClass(name) {
      const module = this.settings.topBarModules && this.settings.topBarModules[name];
      return module && typeof module.className === "string" ? module.className : "";
    },
    shouldTrackRoutePageview() {
      return !this.$route.query.pid;
    },
    showNotFoundMessage() {
      this.finishPageLoading();
      this.$swal({
        title: "No disponible",
        text: `Lo que buscabas no fue encontrado`,
        closeOnClickOutside: false,
        buttons: {
          cancel: "Salir",
          confirm: "Ir a tienda demo",
        },
      }).then((value) => {
        console.log("value", value);
        if (value == null) window.close();
        else {
          document.location.href = "https://pedidos.ticketapp.cl/demo";
        }
      });
    },
    sendRecover() {
      if (this.emailIsValid) return;
      this.$http
        .post("account/recover", { email: this.email })
        .then(() => {
          this.$bvToast.toast("Se ha enviado un correo con las instrucciones", {
            title: "Recuperar cuenta",
            variant: "success",
            solid: true,
          });
          this.$refs["modal-recover"].hide();
        })
        .catch(() => {
          this.$bvToast.toast("No se ha podido enviar el correo", {
            title: "Recuperar cuenta",
            variant: "danger",
            solid: true,
          });
        });
    },
    goHome() {
      this.$router.push(this.getLink(""));
    },
    async checkProduct() {
      if (!this.info || !this.info._id) return;
      const pid = this.$route.query.pid;
      if (!pid) {
        this.productRequestId += 1;
        this.pendingProductKey = "";
        this.modalProduct = null;
        this.modalProductKey = "";
        this.pid = null;
        this.$refs.modal.hide();
        this.setTitle();
        return;
      }

      const key = `${this.info.webName}/${pid}`;
      if (this.pendingProductKey === key) return;
      if (this.modalProduct && this.modalProductKey === key) {
        this.pid = pid;
        this.$refs.modal.show();
        return;
      }

      const requestId = ++this.productRequestId;
      this.pendingProductKey = key;
      try {
        const response = await this.$http.get(`${this.info.webName}/product/${pid}`);
        if (requestId !== this.productRequestId || `${this.$route.query.pid}` !== `${pid}`) return;
        const product = response.data && response.data.data;
        if (!product || !product._id) throw new Error("Producto no disponible");
        this.modalProduct = product;
        this.modalProductKey = key;
        this.pid = pid;
        this.productName = product.name || "Producto";
        this.$refs.modal.show();
      } catch (error) {
        if (requestId !== this.productRequestId) return;
        this.showProductLoadError();
      } finally {
        if (requestId === this.productRequestId) this.pendingProductKey = "";
      }
    },
    showProductLoadError() {
      this.modalProduct = null;
      this.modalProductKey = "";
      this.pid = null;
      this.$refs.modal.hide();
      this.$bvToast.toast("El producto ya no está disponible o no se pudo cargar. Inténtalo nuevamente.", {
        title: "No pudimos abrir el producto",
        variant: "danger",
        solid: true,
      });
      const query = { ...this.$route.query };
      delete query.pid;
      delete query.producto;
      this.$router.replace({ path: this.$route.path, query }).catch(() => {});
    },
    handleModalProductError() {
      this.productRequestId += 1;
      this.showProductLoadError();
    },
    setTitle() {
      if (this.info.name)
        document.title = this.info.custom_name || this.info.name;
    },
    closeModal() {
      console.log("close modal");
      this.productRequestId += 1;
      this.pendingProductKey = "";
      this.modalProduct = null;
      this.modalProductKey = "";
      this.pid = null;
      this.$store.commit("clearEditingCartProduct");
      this.$router.push({ query: {} });
    },
    updateProductData(data) {
      console.log("update product data");
      if (typeof data === "string") {
        this.productName = data;
        return;
      }

      if (!data || typeof data !== "object") return;

      this.productName = data.name || this.productName;

      if (this.$route.query.pid && data.loaded) {
        this.trackWebSessionEvent({
          eventType: "pageview",
          route: this.$route,
          path: data.path || this.$route.fullPath,
          pageTitle: data.pageTitle || document.title || "",
          referer: document.referrer || "",
          force: true,
        });
      }
    },
    viewProduct(pid, pname = "") {
      if (pname) this.productName = pname;
      if (`${this.$route.query.pid}` === `${pid}`) this.checkProduct();
      else this.$router.push({ query: { ...this.$route.query, pid, producto: pname } }).catch(() => {});

      this.$gtag.event("product_view", {
        event_category: "product",
        event_label: "User view product",
        value: 1,
      });
      if (this.settings.facebookPixelEnabled && this.$analytics) {
        console.log("track view content");
        this.safeFbq("track", "ViewContent", {
          pid,
          content_name: pname,
        });
      }
    },
    logout() {
      this.$cookies.remove("token");
      this.$cookies.remove("clientName");
      this.$cookies.remove("phone");
      this.$cookies.remove("email");
      this.$store.commit("setCartLoadedBusiness", null);
      this.$router.push(this.getLink(""));
      this.$nextTick(() => {
        this.loadRemoteCart({ force: true });
      });
    },
    createAccount() {
      this.loading = true;
      this.$http
        .post(`account`, {
          name: this.clientName,
          email: this.email,
          password: this.password,
          phone: this.phone,
        })
        .then(() => {
          this.password = "";
          this.repassword = "";
          this.$bvToast.toast(
            "Se envio un correo de confirmacion a tu correo electronico",
            {
              title: "Cuenta creada",
              variant: "success",
              solid: true,
            }
          );
        })
        .catch(({ data }) => {
          const { details } = data;
          this.$bvToast.toast(
            details || "Ocurrio un error al crear la cuenta",
            {
              title: "Error",
              variant: "danger",
              solid: true,
            }
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    login() {
      this.loading = true;
      this.$http
        .post(`account/auth`, {
          email: this.email,
          password: this.password,
        })
        .then((res) => {
          this.password = "";
          this.$cookies.set("token", res.data.data.token);
          this.$cookies.set("email", res.data.data.email);
          this.$cookies.set("clientName", res.data.data.name);
          this.$cookies.set("phone", res.data.data.phone);
          this.loadRemoteCart({ force: true }).finally(() => {
            this.$router.push(this.getLink("cuenta"));
          });
        })
        .catch(({ data }) => {
          const { details } = data;
          console.log({ details });
          this.$bvToast.toast(details || "Usuario o contraseña incorrecto", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showModalRecover() {
      this.$refs["modal-recover"].show();
    },
    showModalCreate() {
      this.$refs["modal-create"].show();
    },
    showSchedule() {
      this.$refs["schedule-modal"].show();
    },
    goWhatsApp() {
      let msg = `Hola me estoy comunicando desde la pagina web`;
      window.open(
        "https://api.whatsapp.com/send?phone=" +
          this.settings.whatsapp +
          "&text=" +
          encodeURIComponent(msg),
        "_blank"
      );
    },
    getWaitTime() {
      return this.settings.waitTime.slice(0, 10);
    },
    openAddres() {
      this.openInMaps(`${this.info.address} - ${this.info.city}`);
    },
    goUp() {
      this.$store.commit("setLastscroll", Date.now());
      window.scroll(0, 0);
      this.$gtag.event("goup_click", {
        event_category: "user",
        event_label: "go to top bottom",
        value: 1,
      });
    },
    load() {
      const pageLoader = document.getElementById("loading");
      if (pageLoader && !this.appInit) {
        pageLoader.classList.remove("is-error");
        const caption = document.getElementById("loading-caption");
        if (caption) caption.textContent = "Cargando menú y horarios...";
      }
      console.log("loading...", this.$moment().format("HH:mm:ss"));
      this.attempt = this.attempt + 1;

      clearTimeout(this.timeout);
      //console.log("route", this.$route);
      const { name } = this.$route.params;
      const domain = document.location.host.replace(":", "");
      const firstSlug = document.location.pathname
        .split("/")
        .filter(Boolean)[0];

      console.log({ domain, name, firstSlug });

      if (
        domain.indexOf(".ticketapp.cl") == -1 &&
        domain.indexOf("localhost") == -1 &&
        domain.indexOf("192.168") == -1 &&
        domain.indexOf("10.0") == -1
      ) {
        console.log("Domain", domain);
        this.$store.commit("setDomainTrue");
      }

      // business name
      let bs = name;
      // check domain mode in store
      if (this.$store.state.isDomain) bs = domain;
      console.log("bs", bs);
      // check if domain is empty
      if (bs == undefined) {
        //bs = 'demo'
        if (this.attempt > 3) {
          // after 3 attempts show not found message
          return this.showNotFoundMessage();
        }
        // try again after 2 seconds
        return (this.timeout = setTimeout(this.load, 2000));
      }

      // load data from api
      this.$http
        .get(`${bs}`)
        .then((res) => {
          if (!res.data.data._id) {
            console.log("no id");
            throw "not_found";
          } else {
            if (!res.data.data.settings) {
              console.log("no settings");
              if (this.attempt > 3) return this.showNotFoundMessage();
              this.$http.post(`${bs}/cache`, {});
              setTimeout(() => {
                this.load();
              }, 3000);

              return;
            }
            // save data to store
            this.$store.commit("setInfo", res.data.data);
            console.log(res.data.data);

            // check status mode for lastseen data
            if (res.data.data.settings.status == "app") {
              console.log("webStatus APP");
              this.$http
                .get(`${res.data.data._id}/lastseen`)
                .then((res) => {
                  this.$store.commit("setLastseen", res.data.data.lastSeen);
                })
                .catch(() => {
                  console.log("invalid lastseen");
                });
            }
          }
        })
        .catch((err) => {
          if (err === "not_found" || err.status == 404) {
            this.showNotFoundMessage();
          } else if (!this.appInit) {
            this.showLoadingError();
          }
        });
      // }
      // 180000
      this.timeout = setTimeout(this.load, 900000);
    },
    showLoadingError() {
      clearTimeout(this.timeout);
      const loader = document.getElementById("loading");
      if (!loader) return;
      loader.classList.add("is-error");
      const caption = document.getElementById("loading-caption");
      if (caption) caption.textContent = "No pudimos cargar la tienda. Revisa tu conexión.";
      const retry = document.getElementById("loading-retry");
      if (retry) retry.onclick = () => this.load();
    },
    finishPageLoading() {
      const loader = document.getElementById("loading");
      if (!loader || loader.classList.contains("is-ready")) return;
      this.$nextTick(() => {
        loader.classList.add("is-ready");
        const removeLoader = () => loader.remove();
        loader.addEventListener("transitionend", (event) => {
          if (event.target === loader && event.propertyName === "opacity") removeLoader();
        });
        setTimeout(removeLoader, 450);
      });
    },
  },
  computed: {
    menuStyle() {
      const style = this.settings.menu && this.settings.menu.style;
      return ["classic", "underline", "pills", "framed", "glass"].includes(style)
        ? style
        : "classic";
    },
    menuSize() {
      const size = this.settings.menu && this.settings.menu.size;
      return ["sm", "md", "lg"].includes(size) ? size : "md";
    },
    menuPosition() {
      if (!this.showHeader) return "static";
      const position = this.settings.menu && this.settings.menu.position;
      return ["static", "sticky", "floating", "fixed"].includes(position)
        ? position
        : "static";
    },
    menuPositionClass() {
      return `menu-position--${this.menuPosition}`;
    },
    menuClasses() {
      return [`menu-style--${this.menuStyle}`, `menu-size--${this.menuSize}`];
    },
    showTopBarServices() {
      const delivery = this.settings.style === "delivery";
      return (
        this.topBarModuleEnabled("status", delivery) ||
        (this.today() && this.topBarModuleEnabled("schedule", delivery)) ||
        (this.settings.showPickup && this.topBarModuleEnabled("pickup", delivery)) ||
        (this.settings.showDelivery && this.topBarModuleEnabled("delivery", delivery)) ||
        (this.settings.waitTime && this.topBarModuleEnabled("waitTime", false)) ||
        (this.settings.minDelivery && this.topBarModuleEnabled("minDelivery", delivery))
      );
    },
    showTopBarSocial() {
      return (
        (this.settings.facebook && this.topBarModuleEnabled("facebook", true)) ||
        (this.settings.instagram && this.topBarModuleEnabled("instagram", true))
      );
    },
    cartCount() {
      return (this.$store.state.products || []).reduce(
        (total, product) => total + (Number(product.qty) || 0),
        0
      );
    },
    cartTotal() {
      return (this.$store.state.products || []).reduce(
        (total, product) => total + (Number(product.total) || 0),
        0
      );
    },
    showFloatingCart() {
      return this.cartCount > 0 && this.$route.path.indexOf("/pedido") === -1;
    },
    emailIsValid() {
      const email = this.email;
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return !re.test(String(email).toLowerCase());
    },
    settings() {
      return this.info && this.info.settings ? this.info.settings : {};
    },
    footerLogoSrc() {
      return this.settings.footerLogo || this.getLogo(this.info.logo);
    },
    resolvedFooterLinks() {
      const savedLinks = Array.isArray(this.settings.footerLinks)
        ? this.settings.footerLinks
        : [];
      const pages = Array.isArray(this.info.pages) ? this.info.pages : [];

      return savedLinks
        .map((link = {}) => {
          const ref = String(link.ref || "");
          const slug = `${link.slug || ""}`.trim();
          const page = pages.find((item) => String(item._id || "") === ref);
          const finalSlug = page ? `${page.slug || ""}`.trim() : slug;
          const pathLabel = finalSlug ? `/${finalSlug}` : "/";

          return {
            ref,
            slug: finalSlug,
            label: (link.label || (page ? page.title : pathLabel))
              .replace(/\s*\([^)]*\)\s*$/, "")
              .trim(),
          };
        })
        .filter((link) => link.label);
    },
    info() {
      return this.$store.state.info;
    },
    products() {
      let p = sessionStorage.getItem("products");
      if (p) return JSON.parse(p);
      else return [];
    },
    total() {
      return this.$store.state.products.reduce((t, a) => t + a.total, 0);
    },
  },
  watch: {
    menuPosition(position) {
      this.$nextTick(() => {
        if (position !== "fixed" && this.$refs.siteHeader) {
          this.$refs.siteHeader.style.top = "";
        }
        this.updateMenuHeight();
      });
    },
    menuSize() {
      this.$nextTick(this.updateMenuHeight);
    },
    menuStyle() {
      this.$nextTick(this.updateMenuHeight);
    },
    $route: function () {
      console.log("change route", this.$route);
      if (!this.info || !this.info._id) return this.load();
      this.checkProduct();
      if (this.shouldTrackRoutePageview()) {
        this.trackPageview(this.$route);
      }
    },
    info() {
      this.setTitle();
      this.checkProduct();
      this.loadRemoteCart();
      if (this.shouldTrackRoutePageview()) {
        this.trackPageview(this.$route);
      }
      if (!this.appInit) {
        const loader = document.getElementById("loading");
        const logoContainer = document.getElementById("loading-logo");
        let logoReady = Promise.resolve();
        if (loader && logoContainer && this.info.logo) {
          const logo = document.createElement("img");
          logo.alt = this.info.custom_name || this.info.name || "Tienda";
          logoReady = new Promise((resolve) => {
            logo.onload = () => {
              loader.classList.add("has-logo");
              resolve();
            };
            logo.onerror = resolve;
          });
          logo.src = this.getLogo(this.info.logo);
          logoContainer.appendChild(logo);
        }

        console.log({ settings: this.settings });

        var link = document.querySelector("link[rel~='icon']");
        let head = document.querySelector("head");
        if (!link) {
          link = document.createElement("link");

          link.rel = "icon";
          head.appendChild(link);
          link.href = this.getLogo(this.info.logo);
        }

        if (this.settings.customFavicon) {
          link.href = this.settings.customFavicon;
        }

        if (this.settings.description) {
          // find meta og:description
          let meta = document.querySelector("meta[property='og:description']");
          if (!meta) {
            meta = document.createElement("meta");
            meta.property = "og:description";
            head.appendChild(meta);
          }
          meta.content = this.settings.description;
        }

        if (this.settings.customCss) {
          console.log("cargando custom css");
          if (document.querySelector("#custom-css")) {
            document.querySelector("#custom-css").remove();
          }
          let css = document.createElement("style");
          css.type = "text/css";
          css.id = "custom-css";
          css.innerHTML = JSON.parse(this.settings.customCss);
          head.appendChild(css);
        }

        if (this.info && this.info.settings.facebookPixelEnabled) {
          console.log("Pixel Enabled");
          this.$analytics.fbq.init(this.info.settings.facebookPixelCode, {
            em: this.info.settings.facebookPixelEmail,
          });
        }

        Promise.race([
          logoReady,
          new Promise((resolve) => setTimeout(resolve, 350)),
        ]).then(() => {
          this.appInit = true;
          this.show = true;
          this.finishPageLoading();
        });
      }
    },
  },
};
</script>

<style>
.schedule-modal__content {
  overflow: hidden;
  border: 0;
  border-radius: 24px;
  box-shadow: 0 24px 70px rgba(15, 45, 44, 0.24);
}

.schedule-modal__body {
  padding: 0;
}

@media (max-width: 575.98px) {
  .schedule-modal .modal-dialog {
    margin: 12px;
  }
}

.header.menu-position--sticky,
.header.menu-position--floating {
  position: sticky !important;
  z-index: 1000 !important;
}
.header.menu-position--sticky {
  top: 0;
}
.header.menu-position--floating {
  top: 12px;
  width: min(calc(100% - 24px), 1380px);
  margin: 12px auto;
  border: 1px solid rgba(38, 70, 47, 0.12);
  border-radius: 18px;
  background-color: #fff;
  box-shadow: 0 18px 44px rgba(16, 36, 25, 0.16);
}
.header.menu-position--sticky {
  background-color: #fff;
  box-shadow: 0 8px 24px rgba(16, 36, 25, 0.08);
}
.header.menu-position--fixed {
  position: fixed !important;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000 !important;
  background-color: #fff;
  box-shadow: 0 8px 24px rgba(16, 36, 25, 0.1);
}
#header .header-navbar {
  --menu-text: #254536;
  --menu-accent: #a65536;
  --menu-surface: #edf4ec;
  --menu-link-x: 0.8rem;
  --menu-link-y: 0.55rem;
  --menu-font-size: 0.82rem;
  color: var(--menu-text);
  min-height: 84px;
  padding: 0.55rem 0.75rem;
  border-radius: 14px;
}
#header .navbar-brand {
  flex: 0 1 auto;
  margin: 0 auto 0 0;
  padding: 0;
}
#header .navbar-brand > div,
#header .navbar-brand > div > .row {
  width: auto;
  margin: 0;
}
#header .navbar-brand .col-auto.col-md-4 {
  flex: 0 0 auto;
  width: auto;
  max-width: none;
  padding-left: 0;
}
#header #name {
  flex: 0 0 auto;
  width: auto;
  max-width: none;
  padding-left: 1rem !important;
  padding-right: 0;
}
#header #name > span {
  display: inline-block;
  color: inherit;
  font-weight: 600;
  line-height: 1.2;
}
#header .navbar-nav {
  align-items: center;
  gap: 0.2rem;
}
.bg-dark #header .header-navbar {
  --menu-text: #f6faf6;
  --menu-accent: #f5ba78;
  --menu-surface: rgba(255, 255, 255, 0.14);
}
#header .menu-size--sm {
  --menu-link-x: 0.55rem;
  --menu-link-y: 0.36rem;
  --menu-font-size: 0.72rem;
}
#header .menu-size--lg {
  --menu-link-x: 1.1rem;
  --menu-link-y: 0.75rem;
  --menu-font-size: 0.94rem;
}
#header .header-navbar .nav-link {
  position: relative;
  padding: var(--menu-link-y) var(--menu-link-x);
  border-radius: 8px;
  font-size: var(--menu-font-size);
  font-weight: 600;
  letter-spacing: 0.04em;
  color: var(--menu-text) !important;
  min-height: 40px;
  transition: background-color 180ms ease, color 180ms ease;
}
#header .menu-style--classic .nav-link:hover,
#header .menu-style--classic .nav-link.font-weight-bold {
  background: var(--menu-surface);
}
#header .menu-style--underline .nav-link::after {
  content: "";
  position: absolute;
  right: var(--menu-link-x);
  bottom: 0;
  left: var(--menu-link-x);
  height: 2px;
  border-radius: 2px;
  background: var(--menu-accent);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 180ms ease;
}
#header .menu-style--underline .nav-link:hover::after,
#header .menu-style--underline .nav-link.font-weight-bold::after {
  transform: scaleX(1);
}
#header .menu-style--pills .nav-link {
  border-radius: 999px;
}
#header .menu-style--pills .nav-link:hover,
#header .menu-style--pills .nav-link.font-weight-bold {
  background: var(--menu-surface);
}
#header .menu-style--framed .nav-link {
  margin: 0 3px;
  border: 1px solid currentColor;
  border-radius: 4px;
}
#header .menu-style--framed .nav-link:hover,
#header .menu-style--framed .nav-link.font-weight-bold {
  background: var(--menu-surface);
}
#header .menu-style--glass {
  --menu-text: #1e402d;
  padding: 5px 12px;
  border: 1px solid rgba(255, 255, 255, 0.65);
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.76);
  box-shadow: 0 12px 30px rgba(28, 50, 36, 0.09);
  backdrop-filter: blur(16px);
}
.bg-dark #header .menu-style--glass {
  --menu-text: #1e402d;
}
.bg-dark #header .menu-style--classic .nav-link:hover,
.bg-dark #header .menu-style--classic .nav-link.font-weight-bold,
.bg-dark #header .menu-style--pills .nav-link:hover,
.bg-dark #header .menu-style--pills .nav-link.font-weight-bold,
.bg-dark #header .menu-style--framed .nav-link:hover,
.bg-dark #header .menu-style--framed .nav-link.font-weight-bold {
  background-color: rgba(255, 255, 255, 0.14) !important;
  color: #f8fafc !important;
}
.bg-dark #header .menu-style--underline .nav-link:hover,
.bg-dark #header .menu-style--underline .nav-link.font-weight-bold {
  color: #f8fafc !important;
}
.bg-dark #header .menu-style--glass .nav-link:hover,
.bg-dark #header .menu-style--glass .nav-link.font-weight-bold {
  background-color: rgba(46, 106, 69, 0.14) !important;
  color: #1e402d !important;
}
#header .header-navbar .nav-link:focus-visible {
  outline: 2px solid var(--menu-accent);
  outline-offset: 2px;
}
#header .menu-style--glass .nav-link:hover,
#header .menu-style--glass .nav-link.font-weight-bold {
  background: rgba(46, 106, 69, 0.11);
}
.header.bg-light {
  background-image: linear-gradient(115deg, #fff 0%, #fff 72%, #f7faf8 100%);
  border-bottom: 1px solid #e8eeea;
}
.header.bg-dark {
  background-image: linear-gradient(115deg, #172432 0%, #192c38 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
#header {
  padding-top: 0.35rem !important;
  padding-bottom: 0.35rem !important;
}
#header .header-navbar {
  min-height: 72px;
  padding: 0.35rem 0.8rem;
}
#header .header__spacer {
  display: none;
}
#header #name > span {
  font-weight: 700;
  letter-spacing: -0.015em;
}
#header .header-brand__subtitle {
  display: block;
  margin-top: 0.18rem;
  color: #697d89;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.13em;
  line-height: 1.2;
  text-transform: uppercase;
}
.header.bg-dark #header .header-brand__subtitle {
  color: rgba(255, 255, 255, 0.7);
}
#header .header-navbar .nav-link {
  gap: 0.1rem;
  min-height: 42px;
  letter-spacing: 0.025em;
}
#header .header-navbar .nav-link.header-nav__cart {
  gap: 0.25rem;
  margin-left: 0.35rem;
  padding: 0.55rem 0.85rem;
  border: 1px solid #e8eeec;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(18, 40, 48, 0.09);
  font-weight: 700;
}
#header .header-navbar .nav-link.header-nav__cart:hover,
#header .header-navbar .nav-link.header-nav__cart.font-weight-bold {
  background: #f3f8f5;
  box-shadow: 0 6px 18px rgba(18, 40, 48, 0.13);
}
#header .header-nav__cart .badge {
  margin-left: 0.15rem;
  border-radius: 999px;
  font-size: 0.72rem;
  line-height: 1.35;
}
.header.bg-dark #header .header-navbar .nav-link.header-nav__cart {
  border-color: rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.1);
  box-shadow: none;
}
.header.bg-dark #header .header-navbar .nav-link.header-nav__cart:hover,
.header.bg-dark #header .header-navbar .nav-link.header-nav__cart.font-weight-bold {
  background: rgba(255, 255, 255, 0.18);
}
@media (max-width: 991.98px) {
  #header .navbar-brand {
    max-width: calc(100% - 62px);
  }
  #header .navbar-toggler {
    margin-left: auto;
    border-color: rgba(70, 99, 99, 0.25);
    border-radius: 10px;
  }
  #header #navbar-toggle-collapse {
    flex-basis: 100%;
    margin-top: 0.45rem;
    padding: 0.45rem;
    border: 1px solid rgba(70, 99, 99, 0.1);
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.94);
  }
  .header.bg-dark #header #navbar-toggle-collapse {
    background: #1b2a36;
  }
  #header #navbar-toggle-collapse .navbar-nav {
    align-items: stretch;
  }
  #header #navbar-toggle-collapse .nav-link {
    min-height: 46px;
    padding: 0.75rem 0.9rem !important;
  }
  #header #navbar-toggle-collapse .nav-link.header-nav__cart {
    margin: 0.3rem 0 0;
  }
  #header #navbar-toggle-collapse .header-nav__cart .badge {
    margin-left: auto;
  }
}
@media (prefers-reduced-motion: reduce) {
  #header .header-navbar .nav-link,
  #header .menu-style--underline .nav-link::after {
    transition: none;
  }
}
.product-modal .modal-dialog {
  width: calc(100% - 24px);
  max-width: 880px;
  margin: 24px auto;
}
.product-modal__content {
  overflow: hidden;
  border: 0;
  border-radius: 20px;
  box-shadow: 0 28px 80px rgba(15, 35, 24, 0.23);
}
.product-modal__header {
  align-items: center;
  padding: 18px 26px;
  border-bottom: 1px solid #e4eae0;
  background: #f7f9f5;
}
.product-modal__header .modal-title {
  color: #234834;
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.25;
}
.product-modal__header .close {
  margin: -8px -10px -8px auto;
  padding: 8px 12px;
  border-radius: 8px;
  color: #234834;
  font-size: 1.8rem;
  opacity: 0.75;
}
.product-modal__header .close:hover,
.product-modal__header .close:focus-visible {
  background: #e8eee5;
  opacity: 1;
}
.product-modal__body {
  padding: 26px;
  background: #fff;
  color: #25372c;
}
@media (max-width: 575.98px) {
  .product-modal .modal-dialog {
    width: calc(100% - 12px);
    margin: 6px auto;
  }
  .product-modal__content {
    border-radius: 14px;
  }
  .product-modal__header {
    padding: 14px 18px;
  }
  .product-modal__header .modal-title {
    font-size: 1rem;
  }
  .product-modal__body {
    padding: 16px;
  }
}
#pre-header .topbar__inner {
  display: flex;
  align-items: center;
  gap: 6px 14px;
  min-height: 34px;
}
#pre-header {
  background-image: linear-gradient(100deg, #1b2a37, #263f4e 55%, #182936);
  box-shadow: inset 0 -1px rgba(255, 255, 255, 0.1);
}
#pre-header .topbar__inner.py-1 {
  padding-top: 0.2rem !important;
  padding-bottom: 0.2rem !important;
}
#pre-header .topbar__services {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  flex-wrap: wrap;
  min-width: 0;
}
#pre-header .topbar__services .badge {
  white-space: normal;
  line-height: 1.3;
}
#pre-header #badge-schedule,
#pre-header #badge-today {
  padding: 0.25rem 0.35rem;
  border: 0;
  background: transparent;
  color: #f4f7fa !important;
  font-size: 0.69rem;
  letter-spacing: 0.02em;
}
#pre-header #badge-schedule .badge-notif {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
#pre-header #badge-pickup,
#pre-header #badge-delivery {
  padding: 0.3rem 0.55rem;
  border-radius: 999px;
  font-size: 0.67rem;
  letter-spacing: 0.02em;
}
#pre-header .topbar__actions,
#pre-header .topbar__social {
  display: flex;
  align-items: center;
}
#pre-header .topbar__actions {
  gap: 12px;
  margin-left: auto;
}
#pre-header .topbar__social {
  gap: 6px;
}
#pre-header .topbar__social a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: #f4f7fa;
}
#pre-header .topbar__account {
  width: auto;
}
#pre-header .topbar__account .dropdown-toggle {
  min-height: 27px;
  padding: 0.25rem 0.65rem;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  background: rgba(6, 17, 27, 0.24);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.03em;
}
#pre-header .topbar__account .dropdown-toggle:hover,
#pre-header .topbar__account .dropdown-toggle:focus-visible {
  background: rgba(255, 255, 255, 0.12);
}
@media (max-width: 767px) {
  #pre-header .topbar__inner {
    flex-wrap: nowrap;
  }
  #pre-header .topbar__actions {
    width: auto;
    justify-content: flex-end;
  }
  #pre-header .topbar__services {
    flex-basis: auto;
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
  }
  #pre-header .topbar__services::-webkit-scrollbar {
    display: none;
  }
  #pre-header .topbar__services .badge {
    flex: 0 0 auto;
    white-space: nowrap;
  }
}
@media (max-width: 575.98px) {
  #pre-header .topbar__account-label,
  #header .header-brand__subtitle {
    display: none;
  }
  #pre-header .topbar__account .dropdown-toggle {
    min-width: 37px;
    padding: 0.25rem 0.4rem;
  }
  #pre-header .topbar__account .dropdown-toggle .mr-2 {
    margin-right: 0 !important;
  }
}
.custom_scroll {
  overflow-y: scroll;
  padding-right: 5px;
}
.custom_scroll::-webkit-scrollbar {
  width: 8px;
}
.custom_scroll::-webkit-scrollbar-track {
  margin: 0 0px;
}
.custom_scroll::-webkit-scrollbar-thumb {
  background: rgba(213, 215, 217, 0.521);
  border-radius: 10px;
  padding: 0 3px;
}
.custom_scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(213, 215, 217, 0.221);
  border-radius: 10px;
  padding: 0 3px;
}
.custom_scrollX::-webkit-scrollbar-track {
  margin: 0 0px;
}
.fs-3 {
  font-size: 1.75rem;
}
#img-header {
  margin-left: -1px;
}
.btn {
  white-space: pre-wrap !important;
}
.modal-dialog {
  width: 98%;
}
.categories {
  overflow-x: hidden;
}
.categories:hover {
  overflow-x: scroll;
}
.bg-pink {
  background-color: #fb6499;
}
.bg-dark .card {
  background: rgba(2, 2, 2, 0.323) !important;
}
.bg-dark .border-bottom {
  border-bottom: 1px solid #dee2e656 !important;
}
.bg-dark .list-group-item {
  background: rgba(237, 237, 237, 0.121) !important;
  color: white;
}
.floating-cart {
  position: fixed;
  right: 20px;
  bottom: 88px;
  z-index: 99;
}
.floating-cart--with-whatsapp {
  bottom: 182px;
}
.floating-cart__button {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 168px;
  padding: 0.8rem 1rem;
  border-radius: 999px;
  background: linear-gradient(135deg, #111827 0%, #1f2937 100%);
  color: #fff !important;
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.24);
}
.floating-cart__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  font-size: 1.1rem;
}
.floating-cart__text small {
  opacity: 0.82;
  line-height: 1.1;
}
.floating-cart__text strong {
  display: block;
  line-height: 1.1;
  font-size: 1rem;
}
.floating-cart__badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 28px;
  height: 28px;
  padding: 0 0.35rem;
  border-radius: 999px;
  background: #ef4444;
  color: #fff;
  font-weight: 700;
  font-size: 0.8rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 24px rgba(239, 68, 68, 0.28);
}
.click {
  cursor: pointer;
}
a {
  color: inherit !important;
  text-decoration: none !important;
}
.ql-align-center {
  text-align: center;
}
.badge-notif {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  z-index: 1;
}
img {
  max-width: 100% !important;
}
.bg-img-1 {
  background: url("/images/food.webp");
}
.bg-img-2 {
  background: url("/images/beanstalk.webp");
}
.bg-img-3 {
  background: url("/images/email-pattern.webp");
}
.bg-img-4 {
  background: url("/images/double-bubble-dark.png");
}
.bg-img-5 {
  background: url("/images/memphis-mini.webp");
}
.bg-img-lined_paper {
  background: url("/images/lined_paper.png");
}
.bg-img-green_cup {
  background: url("/images/green_cup.png");
}
.bg-img-hip-square {
  background: url("/images/hip-square.png");
}
.bg-img-christmas {
  background: url("/images/christmas-colour.png");
}
.bg-img-christmas-black {
  background: url("/images/christmas-black.png");
}
.web-footer__logo {
  max-width: 180px;
  max-height: 120px;
  object-fit: contain;
}
.web-footer__brand {
  font-size: 1.75rem;
  line-height: 1.05;
}
.web-footer__description {
  max-width: 320px;
  margin: 0.65rem auto 0;
  opacity: 0.92;
}
.web-footer__socials {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
}
.web-footer__social-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  font-size: 1.1rem;
}
.web-footer__section-title {
  margin-bottom: 0.9rem;
  font-size: 1.05rem;
}
.web-footer__links,
.web-footer__utility-links {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}
.web-footer__page-link {
  display: inline-block;
  opacity: 0.92;
}
.web-footer__map-link {
  display: inline-block;
  font-weight: 600;
  opacity: 0.96;
}
@media (max-width: 767px) {
  #header {
    padding-left: 10px;
    padding-right: 10px;
  }
  #header {
    padding-top: 0.4rem !important;
    padding-bottom: 0.4rem !important;
  }
  #header .header-navbar {
    min-height: 0;
    padding: 0.4rem 0.35rem;
    border-radius: 12px;
  }
  #header .navbar-brand {
    max-width: calc(100% - 58px);
    margin-right: 0.5rem;
  }
  #header .navbar-brand .w-75 {
    width: 100% !important;
  }
  #header .navbar-brand .row {
    flex-wrap: nowrap;
    align-items: center;
  }
  #header .navbar-brand .col-auto {
    flex: 0 0 auto;
    width: auto;
    padding-right: 0;
  }
  #header #logo {
    display: block;
    max-width: 100% !important;
    max-height: none;
    width: auto;
    margin: 0 auto;
  }
  #header #name {
    flex: 1 1 auto;
    max-width: none;
    padding-left: 0.75rem !important;
    padding-right: 0;
  }
  #header #name > span {
    font-size: 0.95rem !important;
    line-height: 1.15;
    white-space: normal;
  }
  #header .navbar-toggler {
    margin-left: auto;
    padding: 0.25rem 0.45rem;
    min-width: 40px;
    min-height: 36px;
    border-radius: 9px;
  }
  #header #navbar-toggle-collapse {
    width: 100%;
    flex-basis: 100%;
    margin-top: 0.55rem;
    background: rgba(255, 255, 255, 0.92);
    color: #111827;
    border-radius: 12px;
    padding: 0.4rem;
    box-shadow: 0 10px 28px rgba(16, 36, 25, 0.12);
  }
  .bg-dark #header #navbar-toggle-collapse {
    background: rgba(15, 23, 42, 0.92);
    color: #f8fafc;
  }
  #header #navbar-toggle-collapse .nav-link,
  #header #navbar-toggle-collapse .nav-item,
  #header #navbar-toggle-collapse .nav-link span,
  #header #navbar-toggle-collapse .nav-link .badge {
    color: inherit !important;
  }
  #header #navbar-toggle-collapse .nav-link {
    padding: 0.8rem 0.9rem !important;
  }
  .floating-cart {
    right: 14px;
    bottom: 74px;
  }
  .floating-cart--with-whatsapp {
    bottom: 174px;
  }
  .floating-cart__button {
    min-width: 0;
    gap: 0.6rem;
    padding: 0.72rem 0.9rem;
  }
  .floating-cart__text strong {
    font-size: 0.95rem;
  }
  .web-footer__description {
    margin-left: auto;
    margin-right: auto;
  }

  .w-300, .w-500, .w-800 {
    width: 100% !important;
  }
}
@media (min-width: 768px) {
  .web-footer__socials {
    justify-content: flex-start;
  }
  .web-footer__description {
    margin-left: 0;
    margin-right: 0;
  }
}
.w-300 {
  width: 300px;
}
.w-500 {
  width: 500px;
}
.w-800 {
  width: 800px;
}
.fs-1 {
  font-size: 2.5rem !important;
}
.fs-2 {
  font-size: 2rem !important;
}
.fs-3 {
  font-size: 1.75rem !important;
}
.fs-4 {
  font-size: 1.5rem !important;
}
.fs-5 {
  font-size: 1.25rem !important;
}
.badge-price {
  top: -40px; 
  left: 0px;
}
.category {
  
}
</style>
